import { render, staticRenderFns } from "./RouterAlt.vue?vue&type=template&id=1665b8a0&scoped=true"
import script from "./RouterAlt.vue?vue&type=script&lang=js"
export * from "./RouterAlt.vue?vue&type=script&lang=js"
import style0 from "./RouterAlt.vue?vue&type=style&index=0&id=1665b8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665b8a0",
  null
  
)

export default component.exports